import type { Novidade } from './tipos';

/** Fase 2 (W24, K9): investimento e poupança, categoria sintética, forma de pagamento na baixa, estorno da baixa e "Diversos". */
export const novidadeCadastrosContabeis: Novidade = {
  id: '2026-10-05-cadastros-contabeis',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'financeiro',
  permissao: 'financeiro.ver',
  textos: {
    pt: {
      titulo: 'Poupança, categoria sintética e estorno da baixa',
      resumo: 'Contas de investimento e poupança, categorias que só agrupam, forma de pagamento na baixa e o botão para estornar uma baixa.',
      passos: [
        'Em Contas e caixas, escolha o tipo Investimento ou Poupança: saldo, extrato e relatórios tratam como as outras contas.',
        'Em Categorias, marque Sintética na categoria que só agrupa. Ela não recebe lançamento e o código da filha nova vem sugerido.',
        'No documento e na baixa, escolha a forma de pagamento. Ela aparece no detalhe e no extrato da conta.',
        'No detalhe do documento, Estornar baixa desfaz a baixa com motivo, sem apagar nada, e o documento volta a ter saldo.',
        'Na conta a pagar, use Diversos para a despesa sem fornecedor ou cadastre o fornecedor ali mesmo.',
      ],
    },
    en: {
      titulo: 'Savings, summary categories and payment reversal',
      resumo: 'Investment and savings accounts, categories that only group, payment method on settlement and a button to reverse a payment.',
      passos: [
        'In Accounts and cash, choose the Investment or Savings type: balance, statement and reports treat it like the other accounts.',
        'In Categories, tick Summary on a category that only groups. It takes no entries and the code of a new child is suggested.',
        'On the document and on settlement, choose the payment method. It shows on the detail and on the account statement.',
        'On the document detail, Reverse payment undoes the payment with a reason, deleting nothing, and the document has a balance again.',
        'On an account payable, use Miscellaneous for an expense with no supplier, or register the supplier right there.',
      ],
    },
    es: {
      titulo: 'Ahorro, categoría sintética y reversión de la baja',
      resumo: 'Cuentas de inversión y ahorro, categorías que solo agrupan, forma de pago en la baja y el botón para revertir una baja.',
      passos: [
        'En Cuentas y cajas, elige el tipo Inversión o Ahorro: saldo, extracto e informes la tratan como a las demás cuentas.',
        'En Categorías, marca Sintética en la categoría que solo agrupa. No recibe asientos y el código de la hija nueva viene sugerido.',
        'En el documento y en la baja, elige la forma de pago. Aparece en el detalle y en el extracto de la cuenta.',
        'En el detalle del documento, Revertir baja deshace la baja con motivo, sin borrar nada, y el documento vuelve a tener saldo.',
        'En la cuenta por pagar, usa Varios para el gasto sin proveedor o registra el proveedor ahí mismo.',
      ],
    },
  },
  imagens: [null, '/novidades/2026-10-05-cadastros-contabeis/categorias.webp', '/novidades/2026-10-05-cadastros-contabeis/baixa.webp', '/novidades/2026-10-05-cadastros-contabeis/estorno.webp', null],
  treinamento: { curso: 'novidades' },
  rota: '/financeiro/contas/a-pagar',
};
